export const useState = <T>(initialValue: T): [() => T, (value: T) => void] => {
  let state = initialValue;
  const getState = () => state;
  const setState = (value: T) => {
    state = value;
  };

  return [getState, setState];
};
